import React from 'react';
import PropTypes from 'prop-types';

class Card extends React.Component {
  static displayName = 'Card';

  static propTypes = {
    title: PropTypes.any.isRequired,
    body: PropTypes.any.isRequired,
    right: PropTypes.any.isRequired,
    link: PropTypes.string,
    onTitleClick: PropTypes.func,
  };

  goToPage = (pathName) => {
    window.location.href = pathName;
  };

  render() {
    let {title, body, right, link, onTitleClick = f=>f} = this.props;

    title = wrapIfString(title, 'h3', 'full-width-card-title');
    body = wrapIfString(body, 'p', 'full-width-card-body');

    return <div className='full-width-card'>
      <div className='row'>
        <div className='col-xs-8 col-lg-9'>
          {link ?
            <span onClick={this.goToPage.bind(null, link)}>{title}</span> :
            <span onClick={onTitleClick}>{title}</span>}
          {body}
        </div>
        <div className='col-xs-4 col-lg-3 full-width-card-right'>
          {right}
        </div>
      </div>
    </div>;
  }
}

function wrapIfString(toTest, tag, className) {
  if (typeof toTest === 'string') {
    let props = className ? {className} : null;

    return React.createElement(tag, props, toTest);
  }
  if (className) {
    return React.cloneElement(toTest, {className});
  }
  return toTest;
}

export default Card;
